import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.SbLandkaart, {
  isVisible: (settings: EnvironmentSettings) => settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.SbLandkaart,
    title: 'SB Landkaart',
    url: '/net/rapportageintern/SBLandkaart/',
    iconclass: 'far fa-map-location-dot',
    target: '_blank',
  }),
});
